import angular from 'angular'

let NotificationListController = function (Notification, $filter, $scope, $state, $mdDialog, Toast) {
  let $ctrl = this;
  $ctrl.$scope = $scope;

  angular.extend($ctrl, {
    detail, 
    orderList,
    formatStatus,
    checkTime,
    handleDelete
  });

  activate();

  function activate() {
    $ctrl.resources = {
      count: 0,
      data: []
    };

    $ctrl.uiState = 'LOADING';

    $ctrl.promise;

    $ctrl.$scope.tableConfig = {
      page: 1,
      limit: 10,
      order: 'created_at DESC',
      like_search: '',
      like_search_fields: [
        'title'
      ]
    };

    $ctrl.$scope.$watch('tableConfig', () => {
      loadData()
    }, true);
  }

  function detail(id) {
    $state.go('notification.detail', {id});
  }

  function orderList(field) {
    var tableConfig = $ctrl.$scope.tableConfig;
    if (tableConfig.order) {
      var currentField = tableConfig.order.split(' ')[0];
      var currentOrder = tableConfig.order.split(' ')[1];

      if (currentField === field) {
        currentOrder = currentOrder === 'DESC' ? 'ASC' : 'DESC';
        tableConfig.order = currentField + ' ' + currentOrder;
      } else {
        tableConfig.order = field + ' ' + 'ASC';
      }
    } else {
      tableConfig.order = field + ' ' + ' ASC';
    }
  }

  function formatStatus(status) {
    if (status === 'SENDING') return 'Enviando'
    if (status === 'SENT') return 'Enviado'
    if (status === 'FAILED') return 'Falha no envio'
  }

  // Local functions

  function loadData() {
    $ctrl.promise = Notification
      .load($ctrl.$scope.tableConfig)
      .then(response => {
        $ctrl.resources = response;
        $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
        $ctrl.$scope.$apply();
      })
      .catch(err => {
        console.log('err:' ,  err);
        $ctrl.uiState = 'ERROR';
      });
  }

  function setPlaceHolderValues(arr) {
  	_.forEach(arr, item => {
  		if (item.description === null || item.description === undefined) {
  			item.description = $filter('translate')('common-not-informed');
  		}
  	});
  }

  function handleDelete(notification, event) {
    let confirmMessage = "notification-detail-delete-confirm-text";

    let confirm = $mdDialog
      .confirm()
      .textContent($filter("translate")(confirmMessage))
      .ariaLabel($filter("translate")(confirmMessage))
      .targetEvent(event)
      .ok($filter("translate")("common-yes"))
      .cancel($filter("translate")("common-cancel"));

    $mdDialog
      .show(confirm)
      .then(() => {
        $ctrl.deleting = true;
        Notification.destroy(notification)
          .then((response) => {
            Toast.success(
              $filter("translate")("notification-detail-delete-success")
            );
            $ctrl.deleting = false;
            loadData()
          })
          .catch((err) => {
            Toast.error($filter("translate")("common-server-error"));
            console.log("err:", err);
            $ctrl.deleting = false;
          });
      })
      .catch(() => {});
  }

  function checkTime(sendAt) {
    let datetime = moment(sendAt);
    return datetime.isAfter(moment());
  }
}

NotificationListController.$inject = ['Notification', '$filter', '$scope', '$state', '$mdDialog', 'Toast'];

export default NotificationListController;



// WEBPACK FOOTER //
// ./client/app/components/notification/notification-list.controller.js